module.exports = __webpack_public_path__ + "static/media/UniNeueBlack-Italic.91c890f1.ttf";